'use client'

import { useEffect, useRef } from 'react'
import { useInView } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { DiscountTooltip, type DiscountTooltipProps } from '@/components/DiscountTooltip/DiscountTooltip'
import { useProductData, useSelectedProductVariant } from '@/components/ProductData/ProductDataProvider'
import { BUNDLE_DISCOUNT_PERCENTAGE } from '@/features/bundleDiscount/bundleDiscount.constants'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { useTracking } from '@/services/Tracking/useTracking'

type Props = {
  offer: ProductOfferFragment
  orientation?: DiscountTooltipProps['orientation']
}

export function BundleDiscountOfferPromotionTooltip({ offer, orientation }: Props) {
  const { t } = useTranslation('purchase-form')
  const tracking = useTracking()
  const productData = useProductData()
  const selectedProductVariant = useSelectedProductVariant()
  const elementRef = useRef(null)
  const justBecameVisible = useInView(elementRef, { once: true })

  const promotionKey = 'BUNDLE_DISCOUNT_FIRST_OFFER'

  const priceAmount = offer.cost.net.amount
  useEffect(() => {
    if (justBecameVisible) {
      tracking.reportViewPromotion({
        promotionId: 'bundle_discount',
        creativeName: promotionKey,
        productId: productData.id,
        productName: productData.displayNameFull,
        productVariant: selectedProductVariant?.typeOfContract,
        priceAmount,
      })
    }
  }, [
    justBecameVisible,
    offer,
    priceAmount,
    productData.displayNameFull,
    productData.id,
    promotionKey,
    selectedProductVariant?.typeOfContract,
    tracking,
  ])
  return (
    <DiscountTooltip
      ref={elementRef}
      subtitle={t('BUNDLE_DISCOUNT_FIRST_OFFER', { percentage: BUNDLE_DISCOUNT_PERCENTAGE })}
      orientation={orientation}
    />
  )
}
